import { render, staticRenderFns } from "./Dispatch.html?vue&type=template&id=50a47b95&scoped=true&external"
import script from "./Dispatch.js?vue&type=script&lang=js&external"
export * from "./Dispatch.js?vue&type=script&lang=js&external"
import style0 from "./Dispatch.vue?vue&type=style&index=0&id=50a47b95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a47b95",
  null
  
)

export default component.exports